export class AccessEvent {
    Id?: number;
    DeviceUid: string;
    DeviceName: string;
    EventId: number;
    Type: number;
    Code: string;
    Source: string;
    Passage: string;
    Result: number;
    EventDate: Date;
    ActionEvents: ActionEvent[];
}

export class ActionEvent {
    Id?: number;
    DeviceUid: string;
    DeviceName: string;
    ParentId: number;
    Source: string;
    EventId: number;
    Command: number;
    Result: number;
    Timestamp: Date;
}

export class AccessExportLog {
    EventDate: string;
    User: string;
    Passage: string;
    Result: string;
    Automation: string;
}